import { CircularProgress } from '@mui/material'
import { Navigate } from 'react-router-dom'

import { Box } from '@/components/ui'
import { useAuthStore } from '@/stores/authStore'

interface IProtectedRouteProps {
  children: React.ReactNode
}

export const ProtectedRoute = ({ children }: IProtectedRouteProps) => {
  const { isAuthenticated, isLoading } = useAuthStore()

  if (isLoading) {
    return (
      <Box variant='flexCenter' minHeight='100vh'>
        <CircularProgress />
      </Box>
    )
  }

  if (!isAuthenticated) {
    return <Navigate to='/login' replace />
  }

  return <>{children}</>
}
